import { Injectable } from '@angular/core';
import { CommonService } from 'src/app-core/services/common.service';
import { Observable } from 'rxjs';
import { ApiCommonService } from 'src/app-core/services/api-common.service';

@Injectable({
  providedIn: 'root'
})

export class BoxContainerService {

  constructor(
    private apiCommonService: ApiCommonService) {
  }

  boxContainerCategories(): Observable<any> {
    return this.apiCommonService.get(`Container/CatgeoryLookUp`);
  }

  boxContainerStyles(queryParam: string): Observable<any> {
    return this.apiCommonService.get(`Container/StyleByCategoryId?${queryParam}`);
  }

  getGridRecords(event: any, searchQuery: string, filterQuery: string): Observable<any> {
    return this.apiCommonService.getGridRecords('Container', event, searchQuery, '', filterQuery);
  }

  getMaterialGridRecords(event: any, searchQuery: string, filterQuery: string): Observable<any> {
    return this.apiCommonService.getGridRecords('Container/Materials', event, searchQuery, '', filterQuery);
  }
  getBoxContainerLookups(queryParam: string): Observable<any> {
    return this.apiCommonService.get(`Container/ContainerLookUp?${queryParam}`);
  }

  getSkidOrientContainersLookups(): Observable<any> {
    return this.apiCommonService.get(`Container/SkidOrientationLookUp`);
  }

  getContainersDetails(containerId: string): Observable<any> {
    return this.apiCommonService.get(`Container/Details?ContainerId=${containerId}`);
  }

  updateMaterials(data: any): Observable<any> {
    return this.apiCommonService.post('Container/UpdateMaterials', data);
  }

  createContainer(data: any): Observable<any> {
    return this.apiCommonService.post('Container', data);
  }

  getFaceLookups(): Observable<any> {
    return this.apiCommonService.get(`Container/FaceLookUp`);
  }

  getLaborMethodLookUp(): Observable<any> {
    return this.apiCommonService.get(`Container/LaborMethodLookUp`);
  }

  getContainerDetails(queryString: string): Observable<any> {
    return this.apiCommonService.get(`Container/Details?${queryString}`);
  }

  updateContainer(data: any): Observable<any> {
    return this.apiCommonService.post('Container/Update', data);
  }

  updateContainerImages(data: any, containerId: string): Observable<any> {
    return this.apiCommonService.post(`ContainerImages/InsertImages?containerId=${containerId}`, data);
  }

  getContainerImages(queryString: string): Observable<any> {
    return this.apiCommonService.get(`ContainerImages/ContainerImages?${queryString}`);
  }

  containerStatusUpdate(data: any): Observable<any> {
    return this.apiCommonService.put(`Container/Delete`, data);
  }

  getLabourTiers(containerId: string, laborTierTypeId: number): Observable<any> {
    return this.apiCommonService.get(`LaborTiers?ContainerId=${containerId}&LaborTierTypeId=${laborTierTypeId}`);
  }

  updateLabourTiers(data: any): Observable<any> {
    return this.apiCommonService.post(`LaborTiers/Update`, data);
  }

  addLabourTiers(data: any): Observable<any> {
    return this.apiCommonService.post(`LaborTiers`, data);
  }

  deleteLabourTiers(data: any): Observable<any> {
    return this.apiCommonService.put(`LaborTiers/DeleteAll`, data);
  }

  deleteImage(data: any): Observable<any> {
    return this.apiCommonService.put(`ContainerImages/Delete`, data);
  }
}
